<template>
  <div>
    <PageBanner 
      title="Our Values" 
      imageSrc="../assets/images/rice-7176354_1280.jpg" 
      altText="Values Banner" 
    />
    <Value1Section />
    <Value2Section />
    <Value3Section />
    <Value4Section />
    <Value5Section />
    <CallToActionSection />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import Value1Section from '@/components/Value1Section.vue';
import Value2Section from '@/components/Value2Section.vue';
import Value3Section from '@/components/Value3Section.vue';
import Value4Section from '@/components/Value4Section.vue';
import Value5Section from '@/components/Value5Section.vue';
import CallToActionSection from "@/components/CallToActionSection.vue";


export default {
  name: "ValuesView",
  components: {
    PageBanner,
    Value1Section,
    Value2Section,
    Value3Section,
    Value4Section,
    Value5Section,
    CallToActionSection
  },
};
</script>
